import { Button } from '@chakra-ui/react';

const VARIANTS = {
	primary: {
		default: {
			bg: ['rgba(47, 99, 231, 0.8)', 'rgba(76, 159, 234, 0.8)'],
			border: '#74BCEF',
			shadow: ['rgba(46, 124, 230, 0.3)', '#8CC7F2'],
			color: 'white',
		},
		disabled: {
			bg: ['rgba(47, 99, 231, 0.8)', 'rgba(76, 159, 234, 0.8)'],
			border: '#74BCEF',
			shadow: ['rgba(46, 124, 230, 0.3)', '#8CC7F2'],
			color: '#A1CBFF',
		},
	},
	red: {
		default: {
			bg: ['rgba(231, 47, 47, 1)', 'rgba(234, 76, 76, 1)'],
			border: '#FF2C2C',
			shadow: ['rgba(230, 46, 46, 0.3)', '#F4BFBF'],
			color: 'white',
		},
		disabled: {
			bg: ['rgba(231, 47, 47, 0.4)', 'rgba(234, 76, 76, 0.4)'],
			border: '#FF9A9A',
			shadow: ['rgba(230, 46, 46, 0.15)', '#F4BFBF'],
			color: '#FF9A9A',
		},
	},
};

const ActionButton = ({
	children,
	onClick,
	variant = 'primary',
	isDisabled = false,
	type = 'button',
	...props
}) => {
	const styles = VARIANTS[variant]?.[isDisabled ? 'disabled' : 'default'];

	const gradient = `radial-gradient(66.66% 73.5% at 50% 100%, ${styles.bg[0]} 0%, ${styles.bg[1]} 100%)`;

	return (
		<Button
			display='flex'
			justifyContent='center'
			alignItems='center'
			gap={2}
			type={type}
			w='full'
			h='52px'
			borderRadius='full'
			fontSize='16px'
			fontWeight={600}
			color={styles.color}
			border={`1px solid ${styles.border}`}
			bgGradient={gradient}
			boxShadow={`0 6px 8px ${styles.shadow[0]}, inset 0 0 6px #EBEBEB, inset 0 5px 10px ${styles.shadow[1]}`}
			isDisabled={isDisabled}
			opacity={isDisabled ? 0.6 : 1}
			onClick={!isDisabled ? onClick : undefined}
			_hover={{ bgGradient: gradient }}
			_active={{ bgGradient: gradient }}
			{...props}
		>
			{children}
		</Button>
	);
};

export default ActionButton;
